import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LowercaseRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const lowercasePath = currentPath.toLowerCase();

    if (currentPath !== lowercasePath) {
      navigate(lowercasePath + location.search, { replace: true });
    }
  }, [location, navigate]);

  return null; // This component doesn't render anything
};

export default LowercaseRedirect;
